import React from "react";
import { VbPageHeader } from "@/components/vb";
import { BuyerCreateWizard } from "./buyer-create/BuyerCreateWizard";

/** Buyer-creation wizard (VB-B1 persona + VB-B2 questions). */
export function BuyerCreatePage() {
  return (
    <div className="vb-create-page">
      <VbPageHeader
        title="New Virtual Buyer"
        subtitle="Define who's evaluating you, then pick what they'd ask AI. We run it across ChatGPT, Gemini and Perplexity."
      />
      <BuyerCreateWizard />
    </div>
  );
}

export default BuyerCreatePage;
